<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}政府健檢預約平台
    </h1>
    <h2 class="my-4 text-h5 font-weight-bold text-center">
      預約前請先協助我們完成基礎資料填寫，預計花費5-10分鐘
    </h2>
    <QuestionContent
      :person.sync="person"
      :valid.sync="valid"
      :問卷.sync="問卷"
    ></QuestionContent>
    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="$router.go(-1)"
          class="mt-12 px-12 mx-2"
          x-large
          color="primary"
        >
          上一頁
        </v-btn>
        <v-btn @click="save" class="mt-12 px-12 mx-2" x-large color="primary">
          下一頁
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QuestionContent from "@/components/QuestionContent/Q1";
export default {
  name: "Q1",
  components: { QuestionContent },
  data: () => ({
    valid: false,
    person: null,
    問卷: null,
  }),
  async created() {
    this.person = { ...this.$store.state.person };
    this.問卷 = this.person.問卷 || {};
  },
  methods: {
    save() {
      let person = { ...this.person };
      person.問卷 = this.問卷;
      this.$store.commit("setState", { person });
      this.$router.push("/questionnaire/2");
    },
  },
};
</script>
